import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import type { CollectionSelection } from "./useSiteListActions";

interface CollectParamsDialogProps {
  open: boolean;
  selectedCount: number;
  onClose: () => void;
  onConfirm: (selection: CollectionSelection) => void;
}

export function CollectParamsDialog(props: CollectParamsDialogProps) {
  const { open, selectedCount, onClose, onConfirm } = props;
  const [selection, setSelection] = useState<CollectionSelection>("all_without_params");

  const handleConfirm = () => {
    onConfirm(selection);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Сбор параметров сайтов</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Выберите сайты для сбора параметров:
        </Typography>
        <FormControl>
          <RadioGroup
            value={selection}
            onChange={(event) => setSelection(event.target.value as CollectionSelection)}
          >
            <FormControlLabel value="all_without_params" control={<Radio />} label="Все без параметров" />
            <FormControlLabel
              value="selected"
              control={<Radio />}
              label={`Выбранные сайты (${selectedCount})`}
              disabled={selectedCount === 0}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Запустить
        </Button>
      </DialogActions>
    </Dialog>
  );
}
